module.exports = __webpack_public_path__ + "static/pureice-2922d4a7ece46f3644744f8caf4e1a4a.jpg";